import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { adminStyles } from "../styles";
import SettingsTemplatesList from "./SettingsTemplatesList";

const useStyle = makeStyles(adminStyles);

function TemplateHome() {
    const classes = useStyle();

    return (
        <Container maxWidth={"xl"} className={`atsGlobalContainer ${classes.root}`}>
            <SettingsTemplatesList />
        </Container>
    );
}

export default TemplateHome;
